var exports = {
  "k": "x61f99309--01a3a9--container",
  "H": "x61f99309--01a3a9--inner-container",
};

module.exports = exports;
